import React from 'react';
import PropTypes from 'prop-types';

import ChipMultiSelect from '../../components/ChipMultiSelect';
import CountryConsentFields from '../../components/CountryConsentFields';
import SectionCard from '../../components/SectionCard';
import { AUDIENCE_OPTIONS } from '../../utils/constants';
import texts from '../../texts.json';

const copy = texts.reengagement.eligibility;
const fields = texts.audienceFields;

const EligibilitySection = ({
  eligibility,
  onToggleSalesStage,
  onToggleCountry,
  onRequireConsentChange,
}) => (
  <SectionCard title={copy.title}>
    <ChipMultiSelect
      label={fields.leadState}
      options={AUDIENCE_OPTIONS}
      selected={eligibility.salesStages}
      onToggle={onToggleSalesStage}
      helperText={copy.anchorNote}
    />

    <CountryConsentFields
      countries={eligibility.countries}
      requireConsent={eligibility.requireConsent}
      onToggleCountry={onToggleCountry}
      onRequireConsentChange={onRequireConsentChange}
      countryLabel={fields.country}
      consentLabel={fields.consentLabel}
    />
  </SectionCard>
);

EligibilitySection.propTypes = {
  eligibility: PropTypes.shape({
    salesStages: PropTypes.arrayOf(PropTypes.string),
    countries: PropTypes.arrayOf(PropTypes.string),
    requireConsent: PropTypes.bool,
  }).isRequired,
  onToggleSalesStage: PropTypes.func.isRequired,
  onToggleCountry: PropTypes.func.isRequired,
  onRequireConsentChange: PropTypes.func.isRequired,
};

export default EligibilitySection;
